import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { useState } from "react";
import {
  useHtzStructuralAssessmentCatalogPutMutation,
  useHtzStructuralAssessmentCatalogShowQuery,
} from "@/services/backend/htz/inspection/api/structural-assessment-catalog-api";
import { deleteItem } from "@/services/backend/htz/inspection/types/structural-assessment-catalog";

export interface DeleteStructuralAssessmentCatalogItemDialogProps {
  catalogId: string;
  itemId: string;
}

export function DeleteStructuralAssessmentCatalogItemDialog({
  catalogId,
  itemId,
}: DeleteStructuralAssessmentCatalogItemDialogProps) {
  const [open, setOpen] = useState(false);
  const { data: catalog } = useHtzStructuralAssessmentCatalogShowQuery({
    id: catalogId,
  });
  const [put, { isLoading, error, isSuccess, reset }] =
    useHtzStructuralAssessmentCatalogPutMutation();

  if (isSuccess) {
    reset();
    setOpen(false);
  }

  if (!catalog) {
    return (
      <Button size="sm" variant="destructive" disabled>
        <Trash2 className="h-4 w-4" />
      </Button>
    );
  }

  const onClick = () => {
    if (isLoading || !catalog) {
      return;
    }

    put(deleteItem(catalog, itemId));
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive">
          <Trash2 className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t(`Vorlage löschen?`)}</DialogTitle>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline">{t("Abbrechen")}</Button>
          </DialogClose>
          <Button onClick={onClick} variant="destructive">
            {t("Löschen")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
